import React, { Component } from 'react';
import { Container, Card, CardBody, Row, Col, Collapse, CardHeader, FormGroup, Button, Input, Label, CardTitle, ToastBody} from "reactstrap";
import { Link } from "react-router-dom";
import Select from 'react-select';
import { MDBDataTableV5 } from "mdbreact";
import { Image } from "react-bootstrap"

import { CircleSlider } from "react-circle-slider";

// RangeSlider
import Nouislider from "nouislider-react";
import "nouislider/distribute/nouislider.css";
//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import "./datatables.scss"

import defaultImg from "../../assets/images/product/prison.jpg";
import { testimonyFilterUrl, testimonyFormOptionsUrl, victimUrl } from '../../helpers/url';

class TestimonyManager extends Component {
    constructor(props) {
        super(props);
        this.state={
            breadcrumbItems : [
                { title : "Testimonies", link : "#" },
                { title : "Manager", link : "#" },
            ],

            options: {
                columns: [
                    { label: "ID", field: "victimId", sort: "asc", width: 20 },
                    { label: "Firstname", field: "firstname", sort: "asc", width: 50 },
                    { label: "Lastname", field: "lastname", sort: "asc", width: 50 },
                    { label: "Legal Name", field: "legalName", sort: "asc", width: 50 },
                    { label: "Birth Year", field: "birthYear", sort: "asc", width: 50 },
                    { label: "Image", field: "img", sort: "asc", width: 50 },
                    { label: "Link", field: "link", sort: "disabled", width: 50 },
                ],
                rows: []
            },

            typeSec: false,
            violationsSec: false,
            locationsSec: false,
            educationalSec: false,
            religiositySec: false,
            maritalSec: false,
            ethnicitySec: false,
            acquisitionLevelSec: false,
            ageSec: false,
            internalAssesmentSec: false,
            
            data: [],
            value: 0,

            filterData: [],

            typeFilterOptions: [
                { name: "Not Defined", value: 1 },
                { name: "Jail/Prison", value: 2 },
                { name: "Political 'Re-eductaion' camps", value: 3},
                { name: "XPCC (Bingtuan)", value: 4 },
                { name: "State-run Orphanages", value: 5},
                { name: "Force Labor", value: 10 },
                { name: "Missing", value: 6 },
                { name: "House Arrest", value: 7 },
                { name: "Detained", value: 8 },
                { name: "Dead", value: 9 },
            ],
            latestStatusFilterOptions: [],
            latestLocationsOptions: [],
            latestEducationOptions : [],
            latestReligiosityOptions : [],
            latestEthnicityOptions : [],
            latestMaritalOptions : [],

            filter: {
                type: [],
                violations: [],
                locations: [],
                educational: [],
                religiosity: [],
                maritalStatus: [],
                ethnicity: [],
                sortType: 1,
                acquisitionLevel: 1,
                age: 0,
                internalAssesmentScore: 0,
            }
        }
    }
    
    handleChange = value => {
        this.setState({filter:{...this.state.filter, age: parseInt(value)}})
    };
    
    componentDidMount() {
        const session = JSON.parse(sessionStorage.getItem('authUser'));
		const accessToken = session.jwtToken;
        let fetchData = fetch(victimUrl, {
            method: "GET",
            headers: {"Content-Type": "application/json", "Authorization": accessToken}
        }).then(res=>res.json())
        
        let fetchFilterOptions = fetch(testimonyFormOptionsUrl, {
            method: "GET",
            headers: {"Content-Type": "application/json", "Authorization": accessToken}
        }).then(res=>res.json())
        
        Promise.all([fetchData, fetchFilterOptions])
        .then(([data, filterOptions]) => {
            var tableRows = {...this.state.options}
            tableRows.rows = data
            tableRows.rows.map( each =>{
                each.link = <Link to={{ pathname: '/testimonyDetail', state: { victimId: each.victimId } }} >
                                View Details
                            </Link>
                each.img = <Image src={each.img === '' ? defaultImg : each.img} rounded style={{height:'170px',width:'170px', alignItems: "center", alt:"image"}}/>
            })
            this.setState({
                options: tableRows,
                data: data,
                latestStatusFilterOptions: [...filterOptions.victimStatus],
                latestLocationsOptions: [...filterOptions.landCodes],
                latestEducationOptions: [...filterOptions.educations],
                latestReligiosityOptions: [...filterOptions.religiousTypes],
                latestMaritalOptions: [...filterOptions.maritalStatus],
                latestEthnicityOptions: [...filterOptions.ethnicities]
            })

        })
        .catch(err => {
            console.log("error", err)
        })
    }

    stateSelect = (selected, filterName) => {
        let selectedOptions = []
        selected.map(each => selectedOptions.push(each.value));
			this.setState({
                filter: {...this.state.filter,
                    [filterName]: selectedOptions
                }
			});
    }
    
    stateHandling = (event) => {
        this.setState({filter:{...this.state.filter, acquisitionLevel: parseInt(event.target.value)}})
    }
    
    stateHandlingInternalAssessment = (event) => {
        this.setState({filter:{...this.state.filter, internalAssesmentScore: parseInt(event.target.value)}})
    }

    runThis = () => {
        const session = JSON.parse(sessionStorage.getItem('authUser'));
		const accessToken = session.jwtToken;
        fetch(testimonyFilterUrl, { // put endpoint here
            method: "POST",
            headers: {"Content-Type": "application/json", "Authorization": accessToken},
            body: JSON.stringify(this.state.filter),
        })
        .then(res=>res.json())
        .then(response => {
            var tableRows = {...this.state.options}
            tableRows.rows = response
            tableRows.rows.map( each =>{
                each.link = <Link to={{ pathname: '/testimonyDetail', state: { victimId: each.victimId } }} >
                                View Details
                            </Link>
                each.img = <Image src={each.img === '' ? defaultImg : each.img} rounded style={{height:'170px',width:'170px', alignItems: "center", alt:"image"}}/>
            })
            this.setState({
                successFilter: true,
                data: response,
                options: tableRows,
            })
        })
		.catch(error => {
			console.log(error, "error")
		})
    }
    
    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>

                    <Breadcrumbs title="Testimony Manager" breadcrumbItems={this.state.breadcrumbItems} />

                        <Row>
                            <Col xl={3} lg={4}>
                                <Card>
                                    <CardHeader className="bg-transparent border-bottom">
                                        <h5 className="mb-0">Filters</h5>
                                    </CardHeader>

                                    <CardBody>
                                        <h5 className="font-size-14 mb-3">Categories</h5> 
                                        

                                        <div id="accordion" className="custom-accordion categories-accordion mb-1">
                                            <div className="categories-group-card">
                                                <Link to="#" onClick={() => this.setState({typeSec : !this.state.typeSec, violationsSec : this.state.violationsSec, locationsSec : this.state.locationSec, educationalSec : this.state.educationalSec, religiositySec:this.state.religiositySec, ethnicitySec: this.state.ethnicitySec, maritalSec: this.state.maritalSec})} className={this.state.typeSec ? "categories-group-list accordian-bg-products" : "categories-group-list"}>
                                                    <i className="mdi mdi-alpha-t-box-outline font-size-16 align-middle mr-2"></i> Type
                                                    <i className={this.state.typeSec === true ? "mdi mdi-minus float-right accor-minus-icon" : "mdi mdi-plus float-right accor-plus-icon"}></i>
                                                </Link>
                        
                                                <Collapse isOpen={this.state.typeSec} id="collapseOne">
                                                    <Select
                                                        menuPortalTarget={document.body} 
                                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                        isMulti
                                                        name="colors"
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                        options={this.state.typeFilterOptions.map((option, idx) => ({
                                                            value: option.value,
                                                            label: option.name,
                                                        }))}
                                                        onChange={selected => {
                                                            this.stateSelect(selected, "type");
                                                        }}
                                                    />
                                                </Collapse>
                                            </div>

                                            <div className="categories-group-card">
                                                <Link to="#" className={this.state.violationsSec ? "categories-group-list accordian-bg-products" : "categories-group-list"} onClick={() => this.setState({violationsSec : !this.state.violationsSec, typeSec : this.state.typeSec, locationsSec : this.state.locationSec, educationalSec : this.state.educationalSec, religiositySec:this.state.religiositySec, ethnicitySec: this.state.ethnicitySec, maritalSec: this.state.maritalSec})}>
                                                    <i className="mdi mdi-eye-minus-outline font-size-16 align-middle mr-2"></i> Latest Status
                                                    <i className={this.state.violationsSec === true ? "mdi mdi-minus float-right accor-minus-icon" : "mdi mdi-plus float-right accor-plus-icon"}></i>
                                                </Link>
                                                <Collapse isOpen={this.state.violationsSec} id="collapseTwo">
                                                    <div>
                                                        <Select
                                                        menuPortalTarget={document.body} 
                                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                        isMulti
                                                        name="colors"
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                        options={this.state.latestStatusFilterOptions.map((option, idx) => ({
                                                            value: option.id,
                                                            label: option.statusEN,
                                                        }))}
                                                        onChange={selected => {
                                                            this.stateSelect(selected, "violations");
                                                        }}
                                                    />
                                                    </div>
                                                </Collapse>
                                            </div>

                                            <div className="categories-group-card">
                                                <Link to="#" onClick={() => this.setState({locationsSec : !this.state.locationsSec, typeSec : false, violationsSec : false, educationalSec : false, religiositySec:false, ethnicitySec: false})} className={this.state.locationsSec ? "categories-group-list accordian-bg-products" : "categories-group-list"} >
                                                    <i className="mdi mdi-map-marker-multiple-outline font-size-16 align-middle mr-2"></i> Place of Arrest/Detention
                                                    <i className={this.state.locationsSec === true ? "mdi mdi-minus float-right accor-minus-icon" : "mdi mdi-plus float-right accor-plus-icon"}></i>
                                                </Link>
                                                <Collapse isOpen={this.state.locationsSec} id="collapseThree">
                                                        <Select
                                                        menuPortalTarget={document.body} 
                                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                        isMulti
                                                        name="colors"
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                        options={this.state.latestLocationsOptions.map((option, idx) => ({
                                                            value: option.codeId,
                                                            label: option.perfectureCityEN+", "+option.cityCountyEN,
                                                        }))}
                                                        onChange={selected => {
                                                            this.stateSelect(selected, "locations");
                                                        }}/>

                                                </Collapse>
                                            </div>

                                            <div className="categories-group-card">
                                                <Link to="#" onClick={() => this.setState({educationalSec : !this.state.educationalSec, typeSec : false, violationsSec : false, locationsSec : false, religiositySec:false, ethnicitySec: false})} className={this.state.educationalSec ? "categories-group-list accordian-bg-products" : "categories-group-list"}>
                                                    <i className="mdi mdi-school-outline font-size-16 align-middle mr-2"></i> Educational Background
                                                    <i className={this.state.educationalSec === true ? "mdi mdi-minus float-right accor-minus-icon" : "mdi mdi-plus float-right accor-plus-icon"}></i>
                                                </Link>
                                                <Collapse isOpen={this.state.educationalSec} id="collapseFour">
                                                    <div>
                                                      <Select
                                                        menuPortalTarget={document.body} 
                                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                        isMulti
                                                        name="colors"
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                        options={this.state.latestEducationOptions.map((option, idx) => ({
                                                            value: option.educationId,
                                                            label: option.educationULY + ", " + option.educationEN ,
                                                        }))}
                                                        onChange={selected => {
                                                            this.stateSelect(selected, "educational"); 
                                                        }}/>
                                                    </div>
                                                </Collapse>
                                            </div>
                                            <div className="categories-group-card">
                                                <Link to="#" onClick={() => this.setState({religiositySec : !this.state.religiositySec, typeSec : false, violationsSec : false, locationsSec : false, educationalSec:false, ethnicitySec: false})} className={this.state.religiositySec ? "categories-group-list accordian-bg-products" : "categories-group-list"}>
                                                    <i className="mdi mdi-islam font-size-16 align-middle mr-2"></i> Religiosity
                                                    <i className={this.state.religiositySec === true ? "mdi mdi-minus float-right accor-minus-icon" : "mdi mdi-plus float-right accor-plus-icon"}></i>
                                                </Link>
                                                <Collapse isOpen={this.state.religiositySec} id="collapseFive">
                                                    <Select
                                                        menuPortalTarget={document.body} 
                                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                        isMulti
                                                        name="colors"
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                        options={this.state.latestReligiosityOptions.map((option, idx) => ({
                                                            value: option.rId,
                                                            label: option.rEN,
                                                        }))}
                                                        onChange={selected => {
                                                            this.stateSelect(selected, "religiousity"); 
                                                        }}/>
                                                    
                                                </Collapse>
                                            </div>
                                            <div className="categories-group-card">
                                                <Link to="#" onClick={() => this.setState({maritalSec : !this.state.maritalSec, religiositySec: false, typeSec : false, violationsSec : false, locationsSec : false, educationalSec:false, ethnicitySec: false})} className={this.state.maritalSec ? "categories-group-list accordian-bg-products" : "categories-group-list"}>
                                                    <i className="mdi mdi-mother-heart font-size-16 align-middle mr-2"></i> Marital Status
                                                    <i className={this.state.maritalSec === true ? "mdi mdi-minus float-right accor-minus-icon" : "mdi mdi-plus float-right accor-plus-icon"}></i>
                                                </Link>
                                                <Collapse isOpen={this.state.maritalSec} id="collapseSix">
                                                    <div>
                                                        <Select
                                                            menuPortalTarget={document.body} 
                                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                            isMulti
                                                            name="colors"
                                                            className="basic-multi-select"
                                                            classNamePrefix="select"
                                                            options={this.state.latestMaritalOptions.map((option, idx) => ({
                                                                value: option.mid,
                                                                label: option.status_en,
                                                            }))}
                                                            onChange={selected => {
                                                                this.stateSelect(selected, "maritalStatus"); //change second parameter "type" when doing for other filters, to key name of state object filter.
                                                            }}
                                                        />
                                                    </div>
                                                </Collapse>
                                            </div>
                                            <div className="categories-group-card">
                                                <Link to="#" onClick={() => this.setState({ethnicitySec : !this.state.ethnicitySec, maritalSec: false, religiositySec: false, typeSec : false, violationsSec : false, locationsSec : false, educationalSec:false})} className={this.state.fitness ? "categories-group-list accordian-bg-products" : "categories-group-list"}>
                                                    <i className="mdi mdi-head-outline font-size-16 align-middle mr-2"></i> Ethnicity
                                                    <i className={this.state.ethnicitySec === true ? "mdi mdi-minus float-right accor-minus-icon" : "mdi mdi-plus float-right accor-plus-icon"}></i>
                                                </Link>
                                                <Collapse isOpen={this.state.ethnicitySec} id="collapseSeven">
                                                    <div>
                                                        <Select
                                                            menuPortalTarget={document.body} 
                                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                            isMulti
                                                            name="colors"
                                                            className="basic-multi-select"
                                                            classNamePrefix="select"
                                                            options={this.state.latestEthnicityOptions.map((option, idx) => ({
                                                                value: option.id,
                                                                label: option.ethnicityEN,
                                                            }))}
                                                            onChange={selected => {
                                                                this.stateSelect(selected, "ethnicity"); //change second parameter "type" when doing for other filters, to key name of state object filter.
                                                            }}
                                                        />
                                                    </div>
                                                </Collapse>
                                            </div>
                                        </div>
                                    </CardBody>

                                    <CardBody className="border-top">
                                        <div>
                                            <h5 className="font-size-14 mb-4">Yearly Income</h5>
                                            <br/>
                                            <Nouislider range={{ min: 0, max: 600 }} tooltips={true} start={[100, 500]} connect />
                                        </div>
                                    </CardBody>

                                    <div className="custom-accordion">
                                        <CardBody className="border-top">
                                            <div>
                                                <h5 className="font-size-14 mb-0"><Link to="#" className="text-dark d-block" onClick={() => this.setState({discount : !this.state.discount})} >Data Acquisition Level <i className={this.state.discount === true ? "mdi mdi-minus float-right accor-minus-icon" : "mdi mdi-plus float-right accor-plus-icon"}></i></Link></h5>
    
                                                <Collapse isOpen={this.state.discount} id="collapseExample1">
                                                        <FormGroup row onChange={event => this.stateHandling(event)}>
                                                    <div className="mt-4">
                                                        <div className="custom-control custom-radio mt-2">
                                                            <Input type="radio" value={1} id="productdiscountRadio6" name="acquisition" className="custom-control-input"/>
                                                            <Label className="custom-control-label" htmlFor="productdiscountRadio6">50% or higher</Label>
                                                        </div>
                                                        <div className="custom-control custom-radio mt-2">
                                                            <Input type="radio" value={2} id="productdiscountRadio5" name="acquisition" className="custom-control-input"/>
                                                            <Label className="custom-control-label" htmlFor="productdiscountRadio5">40% or higher</Label>
                                                        </div>
                                                        <div className="custom-control custom-radio mt-2">
                                                            <Input type="radio" value={3} id="productdiscountRadio4" name="acquisition" className="custom-control-input"/>
                                                            <Label className="custom-control-label" htmlFor="productdiscountRadio4">30% or higher</Label>
                                                        </div>
                                                        <div className="custom-control custom-radio mt-2">
                                                            <Input type="radio" value={4} id="productdiscountRadio3" name="acquisition" className="custom-control-input"/>
                                                            <Label className="custom-control-label" htmlFor="productdiscountRadio3">20% or higher</Label>
                                                        </div>
                                                        <div className="custom-control custom-radio mt-2">
                                                            <Input type="radio" value={3} id="productdiscountRadio2" name="acquisition" className="custom-control-input"/>
                                                            <Label className="custom-control-label" htmlFor="productdiscountRadio2">10% or higher</Label>
                                                        </div>
                                                        <div className="custom-control custom-radio mt-2">
                                                            <Input type="radio" value={3} id="productdiscountRadio1" name="acquisition" className="custom-control-input"/>
                                                            <Label className="custom-control-label" htmlFor="productdiscountRadio1">Less than 10%</Label>
                                                        </div>
                                                    </div>
                                                    </FormGroup>
        
                                                </Collapse>
                                            </div>
                                        </CardBody>
    
                                        <CardBody className="border-top">
                                            <div>
                                                <h5 className="font-size-14 mb-0"><Link to="#" className="text-dark d-block" onClick={() => this.setState({size : !this.state.size})}>Age <i className={this.state.size === true ? "mdi mdi-minus float-right accor-minus-icon" : "mdi mdi-plus float-right accor-plus-icon"}></i></Link></h5>
    
                                                <Collapse isOpen={this.state.size} id="collapseExample2">
        
                                                    <div className="mt-4">
                                                        <Col xl={4} sm={6}>
                                                            <div className="text-center mt-4">

                                                                <div dir="ltr">

                                                                    <CircleSlider showTooltip={true} value={this.state.value} onChange={this.handleChange} />

                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </div>
        
                                                </Collapse>
                                            </div>
                                        </CardBody>
                                        <CardBody className="border-top">
                                            <div>
                                                <h5 className="font-size-14 mb-0"><Link to="#" className="collapsed text-dark d-block" onClick={() => this.setState({rating : !this.state.rating})}>Internal Assesment Rating <i className={this.state.rating === true ? "mdi mdi-minus float-right accor-minus-icon" : "mdi mdi-plus float-right accor-plus-icon"}></i></Link></h5>
    
                                                <Collapse isOpen={this.state.rating} id="collapseExample3">
                                                     <FormGroup row onChange={event => this.stateHandlingInternalAssessment(event)}>
                                                    <div className="mt-4">
                                                        <div className="custom-control custom-radio mt-2">
                                                            <Input type="radio" id="productratingRadio1" name="productratingRadio1" className="custom-control-input"/>
                                                            <Label className="custom-control-label" htmlFor="productratingRadio1">4 <i className="mdi mdi-star text-warning"></i>  & Above</Label>
                                                        </div>
                                                        <div className="custom-control custom-radio mt-2">
                                                            <Input type="radio" id="productratingRadio2" name="productratingRadio1" className="custom-control-input"/>
                                                            <Label className="custom-control-label" htmlFor="productratingRadio2">3 <i className="mdi mdi-star text-warning"></i>  & Above</Label>
                                                        </div>
                                                        <div className="custom-control custom-radio mt-2">
                                                            <Input type="radio" id="productratingRadio3" name="productratingRadio1" className="custom-control-input"/>
                                                            <Label className="custom-control-label" htmlFor="productratingRadio3">2 <i className="mdi mdi-star text-warning"></i>  & Above</Label>
                                                        </div>
                                                        <div className="custom-control custom-radio mt-2">
                                                            <Input type="radio" id="productratingRadio4" name="productratingRadio1" className="custom-control-input"/>
                                                            <Label className="custom-control-label" htmlFor="productratingRadio4">1 <i className="mdi mdi-star text-warning"></i></Label>
                                                        </div>
                                                    </div>
                                                    </FormGroup>
                                                </Collapse>
                                            </div>
                                        </CardBody>
                                        <CardBody className="border-top">
                                            <div>
                                                <Button onClick={this.runThis}>Filter</Button>
                                            </div>
                                        </CardBody>
                                    </div>
                                </Card>
                            </Col>
                            <Col lg={9}>
                                <Card>
                                    <CardBody>
                                        <CardTitle className="h4">Available Testimonies</CardTitle>
                                        <MDBDataTableV5 
                                            hover
                                            entriesOptions={[5, 10, 25]} 
                                            responsive 
                                            filter='gender' // needs pro version
                                            entries={5} 
                                            pagesAmount={10} 
                                            data={this.state.options} 
                                            searchTop 
                                            searchBottom={false}
                                        />
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        
                        
                    </Container> 
                </div>
            </React.Fragment>
        );
    }
}

export default TestimonyManager;